import {
  ChangeDetectorRef,
  inject,
  Injectable,
  OnDestroy,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { first, Subscription } from 'rxjs';

import { isLabelData, labelData } from '@VineyardLib/data/label-data';
import { convertToString } from '@VineyardLib/utils/typeConversion.util';

@Injectable({ providedIn: 'root' })
/**
 * 値 (単位)形式にフォーマットします。
 * ※翻訳の処理内容についてはngx-translateのtranslate.pipeを参考に実装
 * 　参考ソース：https://github.com/ngx-translate/core/blob/master/packages/core/lib/translate.pipe.ts
 */
@Pipe({
  name: 'labelTranslate',
  pure: false, // 翻訳が適切なタイミングで実行されるようにするためにfalseを設定　参照: https://angular.dev/api/core/Pipe#pure
})
export class LabelTranslatePipe implements PipeTransform, OnDestroy {
  private translateService = inject(TranslateService);

  private value = '';
  private lastKey?: string | labelData;
  private onLangChange?: Subscription;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  transform(key: string | labelData | undefined): string {
    if (key == null || key == '') {
      return '';
    }

    // 不要な呼び出しを避けるため、 翻訳対象が前回と同じ場合は翻訳しない
    if (key == this.lastKey) {
      return this.value;
    }

    if (isLabelData(key)) {
      const translatedLabel = this.translateService.instant(key.label);
      const translatedUnit = this.translateService.instant(key.unit);
      this.value = `${translatedLabel} (${translatedUnit})`;
    } else {
      this.value = this.translateService.instant(convertToString(key));
    }

    this.lastKey = key;

    this.dispose();

    if (!this.onLangChange) {
      // 翻訳ファイルがロード済みになったタイミング、言語が変更されたタイミングで、再度翻訳処理を走らせる
      this.onLangChange = this.translateService.onLangChange
        .pipe(first())
        .subscribe(() => {
          this.lastKey = undefined;
          this.changeDetectorRef.markForCheck();
        });
    }

    return this.value;
  }

  ngOnDestroy(): void {
    this.dispose();
  }

  private dispose(): void {
    if (this.onLangChange != null) {
      this.onLangChange.unsubscribe();
      this.onLangChange = undefined;
    }
  }
}
